const RadioIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.439 22.656C20.628 23.175 20.362 23.749 19.843 23.939C19.73 23.981 19.614 24 19.499 24C19.091 24 18.708 23.749 18.56 23.343L12 5.411L8.492 15H13C13.553 15 14 15.448 14 16C14 16.552 13.553 17 13 17H7.76L6.663 20H15C15.553 20 16 20.448 16 21C16 21.552 15.553 22 15 22H5.931L5.439 23.344C5.249 23.863 4.673 24.128 4.156 23.939C3.637 23.749 3.371 23.175 3.561 22.656L10.597 3.423C10.229 3.06 10 2.557 10 2C10 0.895 10.895 0 12 0C13.105 0 14 0.895 14 2C14 2.557 13.771 3.06 13.403 3.423L20.439 22.656Z"
      fill="currentColor"
    />
    <path
      d="M6.804 6C7.549 6.019 8.064 5.14 7.668 4.499C7.231 3.744 7 2.88 7 2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M17 2C17 2.88 16.769 3.744 16.332 4.499"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M18.85 8.839C21.296 6.745 22.7 3.698 22.7 0.48"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5.15 8.839C2.704 6.745 1.3 3.698 1.3 0.48"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default RadioIcon;